import { Component, Input, Inject } from "@angular/core";
import { FormGroup, FormArray } from "@angular/forms";
import { PollinationType } from "../../../../../shared/services/pollination-type.service";
import { ConjunctionEnum } from "../../../../../shared/models/conjunction.enum";
import { CE_REQUEST_OPTIONS, ResolvedRequestOptionsService } from "../../../../services/resolved-request-options";
import { PollinationTypeEnum } from "../../../../../shared/services/pollination-stake-label.service";

@Component({
  selector: "app-pollination-preference-item-list",
  templateUrl: "./pollination-preference-item-list.component.html",
  styleUrls: []
})
export class PollinationPreferenceItemListComponent {
  @Input() preferenceGroup: FormGroup;

  public pollinationTypes: PollinationType[];
  public pollinationTypeEnum = PollinationTypeEnum;

  public get conjunctionEnum() {
    return ConjunctionEnum;
  }

  public get items(): FormArray {
    return <FormArray>this.preferenceGroup.get("items");
  }

  constructor(@Inject(CE_REQUEST_OPTIONS) private routeData: ResolvedRequestOptionsService) {
    this.pollinationTypes = this.routeData.requestOptions.pollinationTypes;
  }

  public getPollinationTypeName(pollinationTypeId: number): string {
    if (!pollinationTypeId || !this.pollinationTypes) {
      return '';
    }

    const pollinationType = this.pollinationTypes.find(pt => pt.id === pollinationTypeId);
    return pollinationType ? pollinationType.name : '';
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-preference-group/pollination-preference-item-list/pollination-preference-item-list.component.ts